import { ApiNetWork } from "@/network/apiNet/apiNet";

//正式用户登录接口
export function apiUserLogin(data: any) {
  return ApiNetWork.get("app/encryptionCustomerLoginFree", data);
}
//游客登录接口
export function apiYkLogin(data: any) {
  return ApiNetWork.get("app/encryptionTouristsFree", data);
}

// 历史记录/主播推荐
export function encryptionHostLive() {
  return ApiNetWork.get("app/encryptionHostLive");
}
// 我的关注
export function encryptionShowFocusHost() {
  return ApiNetWork.get("app/encryptionShowFocusHost");
}
//获取个人信息
export function encryptionShowCustomer() {
  return ApiNetWork.get("app/encryptionShowCustomer");
}
// 签到数据
export function encryptionScoreHome() {
  return ApiNetWork.get("app/ScoreHome");
}

export function encryptionFocusHost(data: any) {
  return ApiNetWork.get("app/encryptionFocusHost", data);
}

// 兑换礼包数据
export function encryptionGiftList(data: any) {
  return ApiNetWork.get("app/GiftList", data);
}
// 兑换商品
export function encryptionUserBuyGift(data: any) {
  return ApiNetWork.get("app/UserBuyGift", data);
}
// 获取用户等级
export function getVipData() {
  return ApiNetWork.get("app/getVipData");
}
// 领取红包
export function vipReward() {
  return ApiNetWork.get("app/vipReward");
}
//  获取手机验证码
export function encryptionSendCode(data: any) {
  return ApiNetWork.get("app/encryptionSendCode", data);
}
//  成为主播实名认证
export function encryptionRealName(data: any) {
  return ApiNetWork.get("app/encryptionRealName", data);
}
// 修改昵称
export function encryptionEditName(data: any) {
  return ApiNetWork.get('app/encryptionEditName', data);
}
// 注销账号
export function logOffCustomer(data: any) {
  return ApiNetWork.get('app/logOffCustomer', data);
}